import apiService from "./apiService";

const getAllTransactions = () => apiService.getAll("backend/transactions");

const transactionService = {
  getAllTransactions,
};

export default transactionService;
